mobileSize = 1200;

let windowResized = false;

function displayMobileCountdown() {
  const infoBanner = $("#siteInfoBannerWidget");
  const countDown = $("#countdown-timer");

  const mobileCountdown = $('<div id="mobileCountdown"></div>');
  const swiperContent = $(".swiper-container-content");

  if (window.innerWidth <= 1218 && !windowResized) {
    mobileCountdown.append(infoBanner);
    mobileCountdown.append(countDown);
    swiperContent.append(mobileCountdown);
    windowResized = true;
  } else if (window.innerWidth > 1218 && windowResized) {
    $(".header-top .container").prepend(infoBanner);
    $(".header-bottom .container").prepend(countDown);
    $("#mobileCountdown").remove();
    windowResized = false;
  }
}




$(document).ready(function () {
    
    const windowSize = $(window).width();
    if (windowSize < 1201) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1200) {
        $('body').removeClass('saffireMobileSize');
    }
    //Signup Input text Reappeare
	var emailInput = $('.emailInputField input');
	emailInput.val('Enter Email');
	emailInput.on("click", function () {
		ClearDefaultText(this, 'Enter Email');
	});
	emailInput.on("blur", function () {
		if ($.trim($(this).val()) == '') {
			$(this).val('Enter Email');
		}
	});
//  setTimeout(function () {
//     $('#hlnk_mobileTicketBtn').appendTo('#mobile-nav');
// }, 3000);
    // new WOW().init(); 
    AOS.init({
        startEvent: 'load'
      });
    $('.generalmessage').prependTo('header');
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    $(".footer-bottom .emailSignup .emailSignupText").html("Subscribe to Nisf updates");
    $(".footer-bottom .emailSignup .emailSubmitButton").html("sign me up!");
  });

$(window).load(function () {
    $(".footerItems1 a").removeClass("button");
  
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12);

    setTimeout(displayMobileCountdown(), 500);
});

$(window).resize(() => {
  displayMobileCountdown();
});